module.exports = __webpack_public_path__ + "static/media/metodo_4.d7316325.png";